import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import NoteRow from './Note/Row';
import { Note } from '../types/api';

export interface NotesListProps {
  notes: Note[];
  isLoading?: boolean;
  emptyMessage?: string;
}

function NotesListContent({ notes, isLoading = false }: NotesListProps) {
  // Handle undefined notes gracefully
  const safeNotes = notes || [];

  return (
    <div data-testid="notes-list">
      {isLoading ? (
        <div className="flex-center py-8">
          <div className="animate-pulse">
            <Trans>Loading...</Trans>
          </div>
        </div>
      ) : (
        <>
          <section className="bookmarks" aria-label={t`Notes`}>
            {safeNotes.map((note) => (
              <NoteRow key={note.id} note={note} />
            ))}
          </section>

          {safeNotes.length === 0 && (
            <div className="text-copy-secondary py-10 text-center">
              <div>
                <img
                  width="450"
                  src="/img/notes_nocontent.png"
                  alt="Notes"
                  className="mx-auto mb-4"
                />
              </div>
              <h3 className="highlight inline_block padding-5 text mb-4">
                <a
                  href="http://blog.instapaper.com/private/85019783416/tumblr_n4yojeI3ey1qz8fxi"
                  target="_blank"
                  className="text-copy-primary hover:underline"
                >
                  <Trans>Introducing Notes</Trans>
                </a>
              </h3>
              <div className="margin-bottom-40 mb-4">
                <Trans>
                  Now you can use Instapaper to create highlights and comments on text
                  from any article!
                </Trans>
              </div>
              <div>
                <a
                  className="button_black_outline border-copy-primary text-copy-primary hover:bg-copy-primary hover:text-bg-primary inline-block border px-4 py-2 transition-colors"
                  href="http://blog.instapaper.com/private/85019783416/tumblr_n4yojeI3ey1qz8fxi"
                  target="_blank"
                >
                  <Trans>Learn More</Trans>
                </a>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

function NotesList(props: NotesListProps) {
  return <NotesListContent {...props} />;
}

export default NotesList;
